import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "./SecondStepJobListing.scss";
import { ApiTypeConstant, PayOptionConstant } from "../../../constants/JobConstant";
import { JobOfferingContext } from "../../../context/JobOfferringContext";
import FireTracking from "../../../assets/FireTracking/fireTracking";
import { TYPE_TRACKING } from "../../../constants/TrackingConstant";
import { JobApi } from "../../../api/jobApi";
import DefaultImage from "../../../assets/images/building.jpg";
import useQueryHook from "../../../customHooks/useQueryHook";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Cookies } from 'react-cookie-consent';

const SecondStepJobListing = () => {
  const baseSerpUrl = process.env.REACT_APP_SERP_BASE_URL;

  const { jobs, setJobs, payOutRev } = useContext(JobOfferingContext);

  const { queryString, queryParams, pixelFire, skipPixelFIre, applyPixelFire } = useQueryHook();
  const getKeyword = () =>
  queryParams.get("keyword") || queryParams.get("query");

  const getSubId = () =>
  queryParams.get("sub_id") || queryParams.get("subid") || queryParams.get("subId");

  const getZip = () =>
  queryParams.get("zip") || queryParams.get("userzip") || queryParams.get("user_zip") || queryParams.get("userZip");

  const keyword = getKeyword();
  const subId = getSubId();
  const zip = getZip();

  const campaignId = queryParams.get("camp_id");
  const source = queryParams.get("source");
  const [currentJobIndex, setCurrentJobIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [skipCount, setSkipCount] = useState(0);
  const [tinyJobsArray, setTinyJobsArray] = useState([]);
  const params = JSON.parse(localStorage.getItem('job-genius-user-info'));
  const currentJob = jobs[currentJobIndex];
  let userCity = useRef("");
  let userState = useRef("");
  let userZip = useRef('');
  let pathId = useRef('');
  const isTesting = queryParams.get('testing');
  const isTesting2 = queryParams.get('testing2');
  const isTesting3 = queryParams.get('testing3');
  const jgcid = queryParams.get('jgcid');
  const [logosMap, setLogosMap] = useState({});
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const [normalJobs, setNormalJobs]= useState([]);
  const [specificJobs,setSpecificJobs]= useState([]);
  const [talentApiJobs,setTalentApiJobs]= useState([]);
  const [talrooApiJobs,setTalrooApiJobs]= useState([]);
  const [keywordImage,setKeywordImage]=useState();
  const userAgent= navigator.userAgent; 
  const isTalentAPIEnable = process.env.REACT_APP_TALENT_API_ENABLE;
  const MILES_TO_KILOMETERS = 1.609344;
  const navigate = useNavigate();

  const testObj = useMemo(() => {

    return {
      keyword,
      campaignId,
      subId,
      source,
      testing: isTesting || false,
      testing2: isTesting2 || false,
      testing3: isTesting3 || false,
      zip,
      page: 0,
      size: 6, // Assuming up to 6 jobs
    };
  }, [keyword, campaignId, isTesting, subId]);

  const redirectToSERP = () => {
    let locationParams = "";
    if (userCity.current && userState.current) {
      locationParams = `${userCity.current},${userState.current}`; // Both city and state are present
    } else if (userCity.current) {
      locationParams = `${userCity.current}`; // Only city is present
    } else if (userState.current) {
      locationParams = `${userState.current}`; // Only state is present
    }
    // window.location.href = `${baseSerpUrl}/${queryString || "?"}&query=${keyword || ""
    // }&job_location=${locationParams}&zip=${userZip.current}`;
 
    const searchParams = new URLSearchParams();

    // Append queryString if it exists
    if (queryString) {
      const parsedQueryString = new URLSearchParams(queryString);
      for (const [key, value] of parsedQueryString.entries()) {
        searchParams.append(key, value);
      }
    }

    // Add other parameters
    if (locationParams) searchParams.append("job_location", locationParams);
    if (userZip.current) searchParams.append("zip", zip || userZip.current);
    navigate(`/search?${searchParams.toString()}`);
  };

  const totalJobs = useMemo(() => {
    const firstThreeJobs = jobs.slice(0, 3).map((job) => job.jobId); // Extract job IDs from the first 3 jobs.
    const filteredTinyJobs = tinyJobsArray.filter(
      (tinyJob) => !firstThreeJobs.includes(tinyJob.jobId) // Exclude jobs already in 'jobs.slice(0, 3)'.
    );

    // Combine the first 3 from 'jobs' and next 3 filtered jobs from 'tinyJobsArray'.
    return [
      ...jobs.slice(0, 3),
      ...filteredTinyJobs.slice(0, 3),
    ];
  }, [jobs, tinyJobsArray]);

  const handleSkip = async (currJob) => {
    setIsDisabledBtn(true);
    const dataTracking = {
      jobId: currJob?.jobId || 0,
      slotNumber: currentJobIndex+1,
      campaignId: Array.isArray(currJob?.campaignId) ? currJob?.campaignId[0] : currJob?.campaignId,
      majorCategory: currJob?.majorCategory,
      conversion: 0,
      keyword,
      inboundUrl: document.referrer + queryString,
      jgcid,
      subid:subId,
      source,
      zip,
      pathId: pathId.current,
    };
    if(currJob?.apiJob){
      pixelFire("apiskip");
      FireTracking(TYPE_TRACKING.skipJob, dataTracking);
    }else{
      FireTracking(TYPE_TRACKING.skipJob, dataTracking);
    }
    skipPixelFIre(currentJobIndex + 1);

    if (skipCount >= 2) {
      // Show FixedTinyJobArray after 3 skips, limited to 6 jobs total
      if (tinyJobsArray.length > 0) {
        setJobs(totalJobs);
      }
      setCurrentJobIndex((prevIndex) => prevIndex + 1);
      setIsDisabledBtn(false);
      setSkipCount(0);
      //Disable Redirect to Serp Pgae After 3 continous skip
      // if (currentJobIndex >= 5 || currentJobIndex >= totalJobs.length - 1) {
      //   pixelFire("eof");
      //   redirectToSERP();
      //   return;
      // }
    } else {
      setCurrentJobIndex((prevIndex) => prevIndex + 1);
      setIsDisabledBtn(false);
      setSkipCount((prev) => prev + 1);
    }
    
     // Redirect to SERP only after all 6 jobs have been shown
    if (currentJobIndex >= 5 || currentJobIndex >= jobs.length - 1) {
      pixelFire("eof");
      redirectToSERP();
      return;
    }

    const nextJobIndex = currentJobIndex + 2;
    if (nextJobIndex < totalJobs.length) {
      const nextJob = totalJobs[nextJobIndex];
      fetchJobLogo(nextJob);
    }
  };

  function registerCoregApplicants(currJob,dataTracking) {
    const shaa = currJob?.shaUrl;
    const userId = currJob?.userId || ''; // Add a fallback if needed
    let uid = Cookies.get('__opix_uid');
    const shaId = shaa.includes('/') ? shaa.split('/').pop() : shaa;
  
    const url = `${process.env.REACT_APP_BASE_URL_SKYNET}api/job?cpc=0&queryString=&shaUrl=${shaId}&uid=${uid}&userId=${userId}`;


    axios.get(url)
      .then(async res => {
     // eslint-disable-next-line no-undef
        if (window.urlTracking) {
          // eslint-disable-next-line no-undef
          window.urlTracking = new URL('api/track', process.env.REACT_APP_BASE_URL_SKYNET).toString();
        }
        const dataa = new URL('api/track', process.env.REACT_APP_BASE_URL_SKYNET).toString();
        console.log("dataaa",dataa)
    
        await FireTracking(TYPE_TRACKING.click, {
          sha: shaId,
          jobId: res?.data?.id ,
          publisherId: res?.data?.publisherId ,
          feedId: res?.data?.feedId,
          gtclid: res?.data?.gtclid,
          ...dataTracking
        });

        let obj={
            "uid": uid,
            "clickId": res?.data?.gtclid,
            "jobId": currJob?.jobId,
            "campaignId": Array.isArray(currJob?.campaignId)? currJob.campaignId[0]:currJob?.campaignId, 
            "coregId": currJob?.coregTinyJobCustomFields?.coregId,
            "dl": window.location.href,
            "zip": currJob?.zip
        

        }
         await JobApi.sendDataToCoreg(obj);

      })
      .catch(error => {
        console.error('API call failed:', error);
      });
  }




const buildDataTracking = (currJob) => ({
  jobId: currJob?.jobId || 0,
  slotNumber: currentJobIndex+1,
  campaignId: Array.isArray(currJob?.campaignId) ? currJob?.campaignId[0] : currJob?.campaignId,
  majorCategory: currJob?.majorCategory,
  conversion: 1,
  keyword,
  inboundUrl: document.referrer + queryString,
  jgcid,
  subid: subId,
  source,
  zip,
  pathId: pathId.current,
  ...(currJob?.coregTinyJobCustomFields?.coregId && {
    coregId: currJob.coregTinyJobCustomFields.coregId
  })
});

const buildShaUrlWithParams = (currJob) => {
  if (!params) return `${currJob.shaUrl}${queryString || ""}`;
  const paramString = queryString
    ? `${queryString}&first_name=${params.firstName}&last_name=${params.lastName}&email=${params.email}&phone=${params.phoneNumber}&zip=${zip || userZip.current}`
    : `?first_name=${params.firstName}&last_name=${params.lastName}&email=${params.email}&phone=${params.phoneNumber}&zip=${zip || userZip.current}`;
  return `${currJob.shaUrl}${paramString}`;
};

const openExternalUrl = (currJob) => {
  if (currJob?.apiType === ApiTypeConstant.APPCAST) {
    const url = new URL(currJob.url, window.location.origin);
    if (subId) url.searchParams.set("subid", subId);
    if (source) url.searchParams.set("source", source);
    window.open(url.toString());
  } else {
    window.open(currJob.url);
  }
};

const handleApply = async (currJob) => {
  setIsDisabledBtn(true);
  try {
    setSkipCount(0);
    const dataTracking = buildDataTracking(currJob);
    payOutRev.current += currJob.bid;

    const hasCoreg = !!currJob?.coregTinyJobCustomFields?.coregId;

    setCurrentJobIndex((prevIndex) => Math.min(prevIndex + 1, jobs.length - 1));
    FireTracking(TYPE_TRACKING.applyJob, dataTracking);

    if (currJob?.apiJob) {
      pixelFire("apiclick");
      if (!hasCoreg) openExternalUrl(currJob);
    } else {
      if (!hasCoreg) {
        const windowAddress = buildShaUrlWithParams(currJob);
        window.open(windowAddress);
      }
    }

    applyPixelFire(currentJobIndex + 1, currJob.bid);

    if (currentJobIndex >= 5 || currentJobIndex >= jobs.length - 1) {
      pixelFire("eof");
      redirectToSERP();
    }

    setIsDisabledBtn(false);
    if (hasCoreg) registerCoregApplicants(currJob);

    const nextJobIndex = currentJobIndex + 2;
    if (nextJobIndex < jobs.length) {
      fetchJobLogo(jobs[nextJobIndex]);
    }

  } catch (error) {
    console.log("Error while firing apply event", error);
    setIsDisabledBtn(false);
  }
};

  const hitApi = async (jobs) => {
    const talentApiJobs = jobs.filter(job => job.apiUrl?.startsWith('talentApi:'));
    const talrooApiJobs = jobs.filter(job => job.apiUrl?.startsWith('talrooApi:'));
  
    const apis = [];
    
    if (talentApiJobs.length > 0 && isTalentAPIEnable) {
      apis.push(handleTalentApiJob(talentApiJobs));
    }
  
    if (talrooApiJobs.length > 0) {
      apis.push(handleTalrooApiJob(talrooApiJobs));
    }
  
    await Promise.allSettled(apis);
  };

 const handleTalentApiJob = async (talentjobs) => {
   let params = [
     keyword && `k=${encodeURIComponent(keyword)}`,
     (talentjobs[0]?.city) ? `l=${encodeURIComponent(talentjobs[0].city)}` : talentjobs[0]?.state && `l=${encodeURIComponent(talentjobs[0].state)}`,
     talentjobs[0]?.country && `country=${encodeURIComponent(talentjobs[0].country)}`,
     userAgent && `useragent=${encodeURIComponent(userAgent)}`,
     talentjobs[0]?.ip && `ip=${encodeURIComponent(talentjobs[0].ip)}`,
     talentjobs[0]?.distance &&
       `radius=${encodeURIComponent(Number(talentjobs[0].distance) * MILES_TO_KILOMETERS)}`,
     "format=json",
     `limit=${encodeURIComponent(talentjobs.length)}`,
     "backfill=0",
   ];
   const apiUrl = `${talentjobs[0].apiUrl.replace("talentApi:", "").trim()}&${params
     .filter(Boolean)
     .join("&")}`;
   try {
     const apiResponse = await axios.get(apiUrl);
     const fetchedJobs = apiResponse?.data?.data?.jobs;
     const updatedJobs = talentjobs
     .map((job, index) => {
       const fetchedJob = fetchedJobs[index];
       return fetchedJob ? { ...job, ...fetchedJob } : null;
     })
     .filter((job) => job !== null);
     setTalentApiJobs(updatedJobs);
   } catch (error) {
    console.error("Error fetching Talent API:", error);
   }
 };

 const handleTalrooApiJob = async (talroojobs) => {
   let params = [
     keyword && `q=${encodeURIComponent(keyword)}`,
     (talroojobs[0]?.city && talroojobs[0].state)? `l=${encodeURIComponent(`${talroojobs[0].city},${talroojobs[0].state}`)}`
     : talroojobs[0]?.zip && `l=${encodeURIComponent(talroojobs[0].zip)}`,
     talroojobs[0]?.ip && `ip=${encodeURIComponent(talroojobs[0].ip)}`,
     talroojobs[0]?.distance &&
       `d=${encodeURIComponent(Number(talroojobs[0].distance) * MILES_TO_KILOMETERS)}`,
     "format=json",
     "logo=1",
     "link=1",
     `limit=${encodeURIComponent(talroojobs.length)}`,
   ];

   const apiUrl = `${talroojobs[0].apiUrl.replace("talrooApi:", "").trim()}&${params
     .filter(Boolean)
     .join("&")}`;
   try {
     const apiResponse = await axios.get(apiUrl);
     const fetchedJobs=apiResponse?.data?.jobs;
     const updatedJobs = talroojobs
     .map((job, index) => {
       const fetchedJob = fetchedJobs[index];
       return fetchedJob ? { ...job, ...fetchedJob } : null;
     })
     .filter((job) => job !== null);
     setTalrooApiJobs(updatedJobs);
   } catch (error) {
      console.error("Error fetching Talroo API:", error);
   }
 };
 useEffect(() => {
   const slottingJobs = [...specificJobs, ...talrooApiJobs, ...talentApiJobs];
   const jobsWithSpecificData = slotJobs(slottingJobs, normalJobs);
   setJobs(jobsWithSpecificData);
 }, [talentApiJobs, talrooApiJobs, normalJobs, specificJobs]);

 const slotJobs = (specificJobs, combinedJobs) => {
  const jobsWithSpecificData = Array(6).fill(null);

  // Place specific jobs into their slots
  specificJobs.forEach((specificJob) => {
    const slot = specificJob.slot - 1;
    if (slot >= 0 && slot < jobsWithSpecificData.length) {
      jobsWithSpecificData[slot] = specificJob;
    }
  });

  // Fill remaining slots with combined jobs
  let combinedIndex = 0;
  for (let i = 0; i < jobsWithSpecificData.length; i++) {
    if (!jobsWithSpecificData[i] && combinedIndex < combinedJobs.length) {
      jobsWithSpecificData[i] = combinedJobs[combinedIndex];
      combinedIndex++;
    }
  }

  return jobsWithSpecificData.filter((job) => job !== null);
};
 
  // const fetchJobLogo = (job) => {
  //   if (!job) return;
  
  //   const companyLogo = job?.importCompanyName || job?.companyName || job?.company || keyword
  //   if(companyLogo){
  //     JobApi.fetchLogo(companyLogo)
  //     .then((logoResponse) => {
  //       const logo = logoResponse?.data?.[0]?.image || job?.companyLogo || job?.logo_url || job?.logo || DefaultImage;

  //       setLogosMap((prevLogosMap) => ({
  //         ...prevLogosMap,
  //         [job.jobId]: logo,
  //       }));
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching logo for company:", error);

  //       setLogosMap((prevLogosMap) => ({
  //         ...prevLogosMap,
  //         [job.jobId]: job?.companyLogo || job?.logo_url || DefaultImage,
  //       }));
  //     });
  //   }
  // };

  const fetchJobLogo = (job) => {
    if (!job) return;
  
   const companyNames = job?.jobType
    ? [keyword]
    : [job?.importCompanyName, job?.companyName, job?.company, keyword].filter(Boolean);
  
    const tryFetchLogo = (index) => {
      if (index >= companyNames.length) {
        setLogosMap((prevLogosMap) => ({
          ...prevLogosMap,
          [job.jobId]: job?.companyLogo || job?.logo_url || DefaultImage,
        }));
        return;
      }
  
      JobApi.fetchLogo(companyNames[index])
        .then((logoResponse) => {
          const logo = logoResponse?.data?.[0]?.image;
  
          if (logo) {
            setLogosMap((prevLogosMap) => ({
              ...prevLogosMap,
              [job.jobId]: logo,
            }));
          } else {
            tryFetchLogo(index + 1); // Try the next company name
          }
        })
        .catch(() => {
          tryFetchLogo(index + 1); // Try the next company name on error
        });
    };
  
    tryFetchLogo(0);
  };
  
   
  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      // Run both API calls in parallel
      const jobDataResponse = await JobApi.getJobApi({ ...testObj });
      const specificJobData = jobDataResponse?.data?.slottingJobResult?.content || [];
      const jobData = jobDataResponse?.data?.normalJobResult?.content || [];
      const tinyJobData = jobDataResponse?.data?.tinyJobResult?.content || [];
      userCity.current = jobDataResponse?.data?.zipLocationCity || jobDataResponse?.data?.userCity || "";
      userState.current = jobDataResponse?.data?.zipLocationState || jobDataResponse?.data?.userState || "";
      userZip.current = jobDataResponse?.data?.userZip || "";
      pathId.current = jobDataResponse?.data?.pathId || 0;
      
      // If fetchedJobs are less than 6, concat with tinyJobData
      const combinedJobs = jobData.length < 6
          ? [...jobData, ...tinyJobData.slice(0, 6 - jobData.length)]
          : [...jobData];

      const jobsWithSpecificData = slotJobs(specificJobData, combinedJobs);

      setTinyJobsArray(tinyJobData);
      setSpecificJobs(specificJobData.filter(job => !job.apiUrl?.startsWith('talrooApi:')));
      setNormalJobs(combinedJobs);
      const jobsToPrefetch = jobsWithSpecificData.slice(0, 2);
      await Promise.allSettled(jobsToPrefetch.map(fetchJobLogo));
      await hitApi(jobsWithSpecificData);
    } catch (err) {
      console.error("Error fetching job data:", err);
    } finally {
      setLoading(false);
    }
  }, [testObj, setJobs]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [testObj]);
  useEffect(()=>{
    if(currentJob){
      const dataTracking = {
        jobId: currentJob?.jobId || 0,
        slotNumber: currentJobIndex+1,
        campaignId: Array.isArray(currentJob?.campaignId) ? currentJob?.campaignId[0] : currentJob?.campaignId,
        majorCategory: currentJob?.majorCategory,
        conversion: 0,
        keyword,
        inboundUrl: document.referrer + queryString,
        jgcid,
        subid:subId,
        source,
        impression: 1,
        zip,
        pathId: pathId.current,
      };
      FireTracking(TYPE_TRACKING.displayJob, dataTracking);
    }
  },[currentJob])

  useEffect(() => {
  const fetchKeywordLogos = async () => {
    try {
      const { data } = await JobApi.getKeywordImage({keyword});
      setKeywordImage(data?.image)
    } catch (error) {
      console.error("Error fetching keyword image:", error);
    }
  };
  fetchKeywordLogos();
}, []);

const getCompanyLogo = (job) =>
  job.companyLogo ||
  job.logo_url ||
  job.logo ||
  keywordImage ||
  logosMap[job.jobId] ||
  DefaultImage;

const getJobTitle = (job) => {
  if (job.titleOverRide === 0) return job.title;
  const keyword = getKeyword();
  const city = userCity.current || "global";
  return `Apply for ${keyword ? keyword : ""} Jobs in ${city}`;
};

const getJobDescription = (job) => {
  const title = job.title || job.jobtitle;
  const location = job.apiJob !== 1 ? ` in ${job.postalCode || "global"}` : "";
  const pay =
    job.payTo || job.payFrom
      ? ` up to $${job.payFrom || job.payTo}/${PayOptionConstant[job.payOption] || ""}`
      : "";
  return `${title}${location}${pay}`;
};

const renderJobContent = (job) => (
  <div className="job-browser">
    <div className="company-image">
      <img
        src={getCompanyLogo(job)}
        alt="companyLogo"
        loading="lazy"
      />
    </div>
    <div className="job-listing">
      <p className="job">
        {job.jobType ? getJobTitle(job) : getJobDescription(job)}
      </p>
    </div>
      <div className="desc">
        {job?.coregTinyJobCustomFields?.description || ""}
      </div>
    <hr />
    <div className="footer-job-button">
      <button
        className="view-job"
        onClick={() => handleApply(job)}
        disabled={isDisabledBtn}
      >
        {job?.coregTinyJobCustomFields?.customApply || "Apply"}
      </button>
      <button
        className="skip-job"
        onClick={() => handleSkip(job)}
        disabled={isDisabledBtn}
      >
        {job?.coregTinyJobCustomFields?.customSkip || "Skip"}
      </button>
    </div>
  </div>
);
  return (
    <div>
    {loading ? (
      <div className="loading-spinner">
        <p>Loading...</p>
      </div>
    ) : currentJob ? (
      renderJobContent(currentJob)
    ) : (
      <p>No more jobs to show</p>
    )}
  </div>
  );
};

export default SecondStepJobListing;
